/* eslint-disable max-len, react/jsx-no-bind */

import PropTypes from "prop-types";
import React from "react";

const ColorSwatch = ({
  colorName,
  displayName,
  metalColor,
  mouseEnterHandler,
  mouseLeaveHandler,
  onClick,
  selected,
  stoneName,
  swatchId
}) => {
  const editStoneColorName = name => name.replace(/[ &]+/g, "_").toLowerCase();

  const handleClick = () => onClick(swatchId);

  const handleMouseEnter = () => mouseEnterHandler(swatchId);

  const handleMouseLeave = () => mouseLeaveHandler();

  const invalidNames = [
    "other",
    "none"
  ];

  const validStoneName = stoneName && !invalidNames.includes(stoneName.toLowerCase());

  const validColorName = colorName && !invalidNames.includes(colorName.toLowerCase());

  return (
    <div
      className={`swatch ${selected ? "selected" : ""}`}
      data-test="color-swatch"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={displayName}
    >
      <div className="swatch-inner">
        { metalColor &&
        <div
          className={`swatch-primary swatch-metal-${metalColor.toLowerCase().replace(/ /g, "-")}`}
        />
        }
        { (validStoneName || validColorName) &&
        <div
          className={`swatch-secondary swatch-stone-${editStoneColorName(stoneName || colorName).replace(/ /g, "-")}`}
        />
        }
      </div>
    </div>
  );
};

ColorSwatch.defaultProps = {
  "colorName": null,
  "displayName": null,
  "metalColor": null,
  "stoneName": null,
  "swatchName": null
};

ColorSwatch.propTypes = {
  "colorName": PropTypes.string,
  "displayName": PropTypes.string,
  "metalColor": PropTypes.string,
  "mouseEnterHandler": PropTypes.func.isRequired,
  "mouseLeaveHandler": PropTypes.func.isRequired,
  "onClick": PropTypes.func.isRequired,
  "selected": PropTypes.bool.isRequired,
  "stoneName": PropTypes.string,
  "swatchId": PropTypes.number.isRequired
};

export default ColorSwatch;
